import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, MessageCircle, X } from "lucide-react";
import { motion } from "framer-motion";
import { ClawMark, Wordmark } from "./Brand";
import { scrollToId } from "./SmoothScroll";
import { waLink } from "../../lib/data";

const LINKS = [
  ["como-funciona", "Como funciona"],
  ["pacotes", "Pacotes"],
  ["galeria", "Eventos"],
  ["faq", "Dúvidas"],
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const go = (id) => {
    setOpen(false);
    if (pathname !== "/") navigate(`/#${id}`);
    else scrollToId(id);
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 inset-x-0 z-50 border-b border-white/5 bg-[#08080C]/70 backdrop-blur-xl"
    >
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 h-[72px] flex items-center justify-between">
        <Link to="/" data-testid="nav-home-logo" className="flex items-center gap-2 group">
          <ClawMark className="w-9 h-9 transition-transform duration-500 group-hover:translate-y-1" />
          <Wordmark />
        </Link>
        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map(([id, label]) => (
            <button key={id} data-testid={`nav-link-${id}`} onClick={() => go(id)}
              className="relative text-sm text-zinc-300 hover:text-white transition-colors after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-[#FFD200] after:transition-[width] after:duration-300 hover:after:w-full">
              {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a href={waLink()} target="_blank" rel="noreferrer" data-testid="nav-whatsapp"
            className="hidden sm:flex items-center gap-2 text-sm text-zinc-200 hover:text-[#FFD200] px-3 py-2 transition-colors">
            <MessageCircle className="w-4 h-4" /> WhatsApp
          </a>
          <Link to="/reservar" data-testid="nav-btn-reservar"
            className="rounded-full bg-[#FFD200] text-[#08080C] font-semibold text-sm px-5 py-2.5 hover:bg-white transition-colors">
            Reservar
          </Link>
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen((o) => !o)} className="lg:hidden p-2 text-white" aria-label="Menu">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-white/5 bg-[#08080C] px-5 py-6 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {LINKS.map(([id, label]) => (
            <button key={id} data-testid={`nav-mobile-link-${id}`} onClick={() => go(id)} className="text-left font-display text-2xl font-bold text-white">
              {label}
            </button>
          ))}
          <a href={waLink()} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-[#FFD200]">
            <MessageCircle className="w-4 h-4" /> Falar no WhatsApp
          </a>
        </div>
      )}
    </motion.header>
  );
};
